import React from 'react';
import { Sparkles } from 'lucide-react';
import { cn } from './lib/utils';
import { ICON_PX } from './lib/iconSizes';

/**
 * AI Insight card — displays data-driven insights with an action.
 *
 * Matches the canonical pattern from the Access page (No-Show Intelligence tab):
 * left accent border, Sparkles icon, "INSIGHT" overline label, body text.
 *
 * <InsightCard>
 *   Attendance Tracking skipped 4 times in 30 days. Suggest reassignment.
 * </InsightCard>
 *
 * <InsightCard action={{ label: 'View Tasks', onClick: () => {} }}>
 *   Dr. Kim at 38% utilization while Dr. Johnson at 100%.
 * </InsightCard>
 */
function InsightCard({ children, action, className, onDismiss }) {
  return (
    <div
      className={cn(
        'rounded-lg border border-nn-border bg-nn-white',
        'border-l-[3px] border-l-aqua',
        'px-4 py-3',
        className,
      )}
    >
      <div className="flex items-start gap-3">
        <Sparkles size={ICON_PX.md} className="text-aqua shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <span className="text-overline text-aqua font-bold uppercase tracking-wider">
            Insight
          </span>
          <p className="text-body text-text-dark mt-1">
            {children}
          </p>
        </div>
        {action && (
          <button
            type="button"
            onClick={action.onClick}
            className="text-body-sm text-aqua font-medium hover:text-aqua-bright transition-colors shrink-0 mt-0.5"
          >
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
}

export { InsightCard };
